app.service('productCardTest', function (front, pageConfig) {
	return {
		get enabled() {
			return front.page() === 'product-detail' && pageConfig.getData('productCard').productCardTestEnabled;
		}
	};
});